import template from './ui-crud-view.html';
import { rest } from 'core/api';
import config from 'config.json';
import { download } from 'core/util';

/**
 * Componente que representa a una vista de CRUD. Util para poder
 * unificar el look & feel de los distintos formularios de la aplicación.
 *
 * Ejemplo de utilización:
 *
 *    <ui-crud-view datatable-options="vm.options" report-options="vm.reportOptions"
 *                  icon-classes="glyph-icon icon-calendar-o" goto-form="vm.gotoForm()"
 *                  goto-form-permissions="create_franjas_horarias">
 *      <ui-crud-header>
 *        <h2>{{ 'Administración de franjas horarias' | translate }}</h2>
 *      </ui-crud-header>
 *
 *      <ui-crud-actions>
 *        <a auth permissions="'configurar_marcaciones'" ng-click="vm.gotoConfigurarForm()" class="btn btn-link font-blue"
 *           title="">
 *          <i class="fa fa-gear font-size-14 opacity-hover"></i> {{'Configurar' | translate}}
 *        </a>
 *      </ui-crud-actions>
 *
 *      <ui-crud-title>{{ 'Listado de franjas horarias' | translate }}</ui-crud-title>
 *
 *      <ui-crud-body>
 *        <ui-datatable options="vm.options"></ui-datatable>
 *      </ui-crud-body>
 *    </ui-crud-view>
 *
 * @author Jorge Ramirez <jorge@codium.com.py>
 */
export let UICrudViewComponent = {
  transclude: {
    headerSlot: 'uiCrudHeader',
    listSlot: 'uiCrudBody',
    listTitleSlot: '?uiCrudTitle',
    headerButtonsSlot: '?uiCrudActions'
  },
  templateUrl: template,
  selector: 'uiCrudView',
  bindings: {
    translations: '=',
    // íconos para el header
    iconClasses: '@',

    // handler para el botón de CREATE
    gotoForm: '&',

    // indica los permisos necesarios para poder ver el botón de CREATE
    gotoFormPermissions: '@',

    // Opcional. Debe hacer referencia al objeto options del datatable. Se debe usar
    // cuando se habilita la generación de reportes.
    datatableOptions: '<',

    // Opcional. Objeto que permite configurar y habilitar los botones para la generación
    // de reportes. Formato:  {title: 'titulo del reporte'}
    // Al habilitar esta opción, se debe también especificar el parámetro datatableOptions.
    reportOptions: '<'
  },
  controller: UICrudViewCtrl,
  controllerAs: 'vm'
};


UICrudViewCtrl.$inject = ['$ngRedux', '$sce', '$resource', 'HeadersUtil'];

function UICrudViewCtrl($ngRedux, $sce, $resource, HeadersUtil) {
  this.generarReporte = generarReporte.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);

  const unsubscribe = $ngRedux.connect(this.mapStateToThis)(this);


  this.$onDestroy = () => {
    unsubscribe();
  };

  this.$onInit = () => {
    $ngRedux.dispatch(rest.actions.reports.reset());
  };

  function mapStateToThis(state) {
    const report = state.reports.data;

    if (report && report.filename && this.modal) {
      this.fileURL = $sce.trustAsResourceUrl(`${config.serverURL}/report/download/${report.filename}`);
      this.modal.open();
    }
    return { report };
  }

  /**
   * Función para generación de reportes a partir del estado
   * del datatable.
   *
   * @param {string} format - pdf | csv
   */
  function generarReporte(format) {
    let payload = Object.assign({}, this.datatableOptions.tableAjaxParams, this.reportOptions);
    payload.endpoint = this.datatableOptions.resource;
    let columns = [];
    this.datatableOptions.currentColumnOrder.forEach(columnName => {
      const columnOrig = payload.columns.filter(c => c.data === columnName)[0];
      let column = Object.assign({}, columnOrig);
      let defColumn = this.datatableOptions.columns.filter(c => c.data === columnName)[0];

      column.title = defColumn.title;


      if (defColumn.name) {
        column.data = defColumn.name;
      }

      columns.push(JSON.stringify(column));
    });
    payload.columns = columns;
    payload.order = payload.order.map(o => JSON.stringify(o));
    payload.search = JSON.stringify(payload.search);
    payload.format = format;
    payload.filter = JSON.stringify(this.datatableOptions.staticFilter);

    if (format === 'pdf') {
      $ngRedux.dispatch(rest.actions.reports(payload, {
        body: JSON.stringify({ tipo: 'pdf', staticFilter: this.datatableOptions && this.datatableOptions.staticFilter })
      }));
    } else if (format === 'csv') {
      download(payload.endpoint, 'report', 'datatables', config, $resource, HeadersUtil, { tipo: 'csv', staticFilter: this.datatableOptions && this.datatableOptions.staticFilter }, payload);
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/components/ui-crud/ui-crud-view/ui-crud-view.component.js